<template>
  <div class="beneficiary-person-form-person-container">
    <!-- <el-dialog
      title="Update Beneficiary"
      :visible.sync="dialogShow"
      :close-on-click-modal="false"
      :width="device === 'mobile' ? '95%' : '80%'"
      :before-close="handleClose"
      top="5vh"
    > -->
      <el-form
        :model="beneficiaryForm"
        id="beneficiaryForm"
        ref="beneficiaryForm"
        label-width="150px"
        size="small"
        :rules="beneficiaryFormRules"
        :label-position="device === 'mobile' ? 'top' : 'right'"
      >
        <el-row :gutter="50">
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-divider content-position="left">Beneficiary</el-divider>
            <el-form-item prop="currency" label="Currency">
              <el-select v-model="beneficiaryForm.currency">
                <el-option  v-for="item in currency"
                    :key="item"
                    :label="item"
                    :value="item.toLowerCase()"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item
              prop="accountnumber"
              label="Account number"
              v-if="beneficiaryForm.currency === 'gbp'"
            >
              <el-input v-model="beneficiaryForm.accountnumber"></el-input>
            </el-form-item>

            <el-form-item
              prop="sortcode"
              label="Sortcode"
              v-if="beneficiaryForm.currency === 'gbp'"
            >
              <el-input v-model="beneficiaryForm.sortcode"></el-input>
            </el-form-item>

            <el-form-item prop="iban" label="IBAN" v-if="checkGBP">
              <el-input v-model="beneficiaryForm.iban"></el-input>
            </el-form-item>

            <el-form-item prop="bic" label="BIC" v-if="checkGBP">
              <el-input v-model="beneficiaryForm.bic"></el-input>
            </el-form-item>


            <el-divider content-position="left">Personal</el-divider>

            <el-form-item prop="personal.name" label="Name">
              <el-input v-model="beneficiaryForm.personal.name"></el-input>
            </el-form-item>

            <el-form-item prop="personal.dateOfBirth" label="Date Of Birth">
              <el-date-picker
                v-model="beneficiaryForm.personal.dateOfBirth"
                type="date"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>

            <el-form-item prop="personal.telephone" label="Telephone">
              <el-input
                prefix-icon="el-icon-phone"
                v-model="beneficiaryForm.personal.telephone"
              ></el-input>
            </el-form-item>

            <el-form-item prop="personal.email" label="Email">
              <el-input
                prefix-icon="el-icon-message"
                v-model="beneficiaryForm.personal.email"
              ></el-input>
            </el-form-item>

            <el-form-item prop="personal.pep" label="PEP">
              <el-switch v-model="beneficiaryForm.personal.pep"></el-switch>
            </el-form-item>

            <el-form-item
              prop="personal.pepType"
              label="PEP Type"
              v-if="beneficiaryForm.personal.pep"
            >
              <el-select v-model="beneficiaryForm.personal.pepType">
                <el-option label="Direct" value="direct"></el-option>
                <el-option
                  label="Close associate"
                  value="close-associate"
                ></el-option>
                <el-option label="Former pep" value="former-pep"></el-option>
                <el-option
                  label="Family member"
                  value="family-member"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item
              prop="personal.pepNotes"
              label="PEP Note"
              v-if="beneficiaryForm.personal.pep"
            >
              <el-input v-model="beneficiaryForm.personal.pepNotes"></el-input>
            </el-form-item>

            <!-- <el-form-item prop="personal.approvedate" label="Approve Date">
              <el-input
                v-model="beneficiaryForm.personal.approvedate"
              ></el-input>
            </el-form-item> -->

            <el-form-item prop="personal.nationality" label="Nationality">
              <el-autocomplete
                prefix-icon="el-icon-s-flag"
                class="inline-input"
                v-model="beneficiaryForm.personal.nationality"
                :fetch-suggestions="querySearchNationality"
              ></el-autocomplete>
            </el-form-item>

            <el-form-item prop="personal.identifyType" label="Identify Type">
              <el-select v-model="beneficiaryForm.personal.identifyType">
                <el-option label="Passport" value="passport"></el-option>
                <el-option
                  label="Driving Licence"
                  value="driving-licence"
                ></el-option>
                <el-option
                  label="Identity Card"
                  value="identity-card"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item prop="personal.identifyNumber" label="Identify Number">
              <el-input
                v-model="beneficiaryForm.personal.identifyNumber"
              ></el-input>
            </el-form-item>

            <el-form-item prop="personal.identifyExpire" label="Identify Expire">
              <el-date-picker
                v-model="beneficiaryForm.personal.identifyExpire"
                type="date"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>

          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-divider content-position="left">Personal Address</el-divider>

            <el-form-item prop="personal.addressnumber" label="Address number">
              <el-input
                v-model="beneficiaryForm.personal.addressnumber"
              ></el-input>
            </el-form-item>

            <el-form-item prop="personal.street" label="Street">
              <el-input v-model="beneficiaryForm.personal.street"></el-input>
            </el-form-item>

            <el-form-item prop="personal.city" label="City">
              <el-input v-model="beneficiaryForm.personal.city"></el-input>
            </el-form-item>

            <el-form-item prop="personal.zipcode" label="Zipcode">
              <el-input v-model="beneficiaryForm.personal.zipcode"></el-input>
            </el-form-item>

            <el-form-item prop="personal.refinement" label="Refinement">
              <el-input
                v-model="beneficiaryForm.personal.refinement"
              ></el-input>
            </el-form-item>

            <el-form-item prop="personal.region" label="Region">
              <el-input v-model="beneficiaryForm.personal.region"></el-input>
            </el-form-item>

            <el-form-item prop="personal.residentCountry" label="Resident Country">
              <el-autocomplete
                class="inline-input"
                v-model="beneficiaryForm.personal.residentCountry"
                :fetch-suggestions="querySearchCountrycode"
                @select="selectResidentCountrycode"
                :maxlength="3"
              >
                <template slot-scope="{ item }">
                  <div>{{ item.country_code }} - {{ item.country_name }}</div>
                </template></el-autocomplete
              >
            </el-form-item>

            <el-form-item prop="personal.countrycode" label="Country code">
              <el-autocomplete
                class="inline-input"
                v-model="beneficiaryForm.personal.countrycode"
                :fetch-suggestions="querySearchCountrycode"
                @select="selectCountrycode"
                :maxlength="3"
              >
                <template slot-scope="{ item }">
                  <div>{{ item.country_code }} - {{ item.country_name }}</div>
                </template></el-autocomplete
              >
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div class="dialog-footer">
            <el-button
              type="primary"
              :loading="submiting"
              @click="submitBeneficiary()"
              >Submit</el-button
            >
            <el-button @click="handleClose">Cancel</el-button>
      </div>

    <!-- </el-dialog> -->
  </div>
</template>

<script>
import model from "./model";
import { getUtility } from "@/api/customer";
import { addBeneficiaryProject } from "@/api/beneficiary";
export default {
  props: {
    dialogShow: Boolean,
    projectUID: String
  },
  computed: {
    device() {
      return this.$store.state.app.device;
    },
    checkGBP(){
      return (this.beneficiaryForm.flagswiftfx === 'international' && this.beneficiaryForm.currency === 'gbp') || this.beneficiaryForm.currency != 'gbp';
    }
  },
  data() {
    return {
      submiting: false,
      errMsg: "",
      utility: {},
      beneficiaryForm: model.person(),
      beneficiaryFormRules: model.personRule,
      currency: []
    };
  },
  methods: {
    getUtility() {
      getUtility().then(({ result, data }) => {
        if (result) {
          this.utility = data;
        }
      });
    },
    addBeneficiaryProject() {
      this.submiting = true;
      this.errMsg = "";
      addBeneficiaryProject(this.projectUID, this.beneficiaryForm).then(
        ({ result, message }) => {
          this.submiting = false;
          if (result) {
            this.$notify({
              title: "Success",
              message: `Add Beneficiary successfully`,
              type: "success",
              duration: 2000
            });
            this.handleClose();
            this.$emit("submited", true);
          } else {
            this.errMsg =
              typeof message === "string"
                ? message
                : "Add Beneficiary Error";
          }
        }
      );
    },
    submitBeneficiary() {
      //this.$emit("on-submited", true);
      this.$refs.beneficiaryForm.validate((valid) => {
        if (valid) {
          //this.addBeneficiaryProject();
          // console.log(this.beneficiaryForm)
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm() {
      if (this.$refs.beneficiaryForm) this.$refs.beneficiaryForm.resetFields();
    },

    querySearchCountrycode(queryString, cb) {
      var data = this.utility.country;
      var results = queryString
        ? data.filter(this.createFilter(queryString, "country_code"))
        : data;
      // const lists = []
      // results.forEach((item)=>{
      //   lists.push({value : item.country_code})
      // })
      cb(results);
    },
    querySearchResidentCountry(queryString, cb) {
      var data = this.utility.country;
      var results = queryString
        ? data.filter(this.createFilter(queryString, "country_code"))
        : data;
      // const lists = []
      // results.forEach((item)=>{
      //   lists.push({value : item.country_name})
      // })
      cb(results);
    },
    querySearchNationality(queryString, cb) {
      var data = this.utility.country;
      var results = queryString
        ? data.filter(this.createFilter(queryString, "nationality"))
        : data;
      const lists = [];
      results.forEach((item) => {
        lists.push({ value: item.nationality });
      });
      cb(lists);
    },

    selectCountrycode(item) {
      this.beneficiaryForm.personal.countrycode = item.country_code;
    },
    selectResidentCountrycode(item) {
      this.beneficiaryForm.personal.residentCountry = item.country_code;
    },
    createFilter(queryString, key) {
      return (item) => {
        return item[key].toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    setModel(swifttype){
      this.beneficiaryForm = model.person()
      this.beneficiaryForm.flagswiftfx = swifttype
      this.currency = model.currency[swifttype]
    },
    handleClose() {
      this.$emit("closed", false);
    },
  },
  created() {
    this.getUtility();
  },
};
</script>

<style lang="scss">
.beneficiary-person-form-person-container {
  .el-form-item--small.el-form-item {
    margin-bottom: 16px;
  }
  .item__label {
    line-height: 30px;
    font-weight: bold;
  }

  .el-form-item__label {
    font-size: 12px;
  }

  .el-divider__text {
    font-weight: bold;
    font-size: 14px;
    color: #424242;
  }

  .dialog-footer{
    text-align: right;
  }
}
</style>